import React from 'react';
import CustomButton from '../../../common/components/CustomButton';
import PopupContainer from '../../../common/components/PopupContainer';
import { MusicAlbumEntity } from '../../types/MusicAlbumEntityTypes';

export default function MusicAlbumDeleteDisabledPopup({
  musicAlbum,
  onClose,
} : {
  musicAlbum: MusicAlbumEntity,
  onClose: () => void,
}) {
  return (
    <PopupContainer title="リリースの削除" onClose={() => { onClose(); }}>
      <form>
        <div className="list__body">
          {musicAlbum.release_status === 1 && (
            <>
              <p>配信の手続き中です。</p>
              <p>編集や削除は行えません。</p>
            </>
          )}
          {musicAlbum.release_status === 3 && (
            <>
              <p>配信停止の手続き中です。</p>
              <p>停止されるまで削除はできません。</p>
            </>
          )}
          {musicAlbum.release_status === 6 && (
            <>
              <p>このリリースを編集・削除することはできません。</p>
            </>
          )}
          {(musicAlbum.release_status === 7 || musicAlbum.release_status === 8 || musicAlbum.release_status === 9) && (
            <>
              <p>配信手続き中のため、削除できません。</p>
              <p>審査結果が出るのをお待ちください。</p>
            </>
          )}
          <p className="top_line" />
          <ul>
            <li className="bt">
              <CustomButton type="cancel" onClick={() => { onClose(); }}>閉じる</CustomButton>
            </li>
          </ul>
        </div>
      </form>
    </PopupContainer>
  );
}
